import React from 'react';
import {Helmet} from 'react-helmet';

export default function Analytics() {
  return (
    <Helmet htmlAttributes={{lang: 'en', translate: 'no'}}>
      <link
        rel='preconnect'
        as='script'
        href='https://europe-west3-the-orca.cloudfunctions.net'
      />
      <link rel='preconnect' as='script' href='https://connect.facebook.net' />
      <script
        async
        src='https://www.googletagmanager.com/gtag/js?id=G-TD1FQ46E1R'
      />
      <script type='text/javascript'>
        {`
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:2951735,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}
      </script>
      <script type='text/javascript'>
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-TD1FQ46E1R');
            
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;t.defer=!0
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '2818427685147135');
            fbq('track', 'PageView');               
      `}
      </script>
      <script type='text/javascript'>
        {`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful')`}
      </script>
      <script async src='https://r.wdfl.co/rw.js' data-rewardful='76d87e' />
      <script type='text/javascript'>
        {`
          (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);})(window.lintrk);
        `}
      </script>
      <script
        SameSite='None; Secure'
        src='https://static.landbot.io/landbot-3/landbot-3.0.0.js'
      />
      <noscript>
        {`<img
        height="1"
        width="1"
        style="display:none"
        src="https://www.facebook.com/tr?id=2818427685147135&ev=PageView&noscript=1"
      />`}
      </noscript>
      <script async src='https://js.stripe.com/v3/pricing-table.js' />
      <meta name='google' content='notranslate' />
      <meta
        name='theme-color'
        content='#000000'
        media='(prefers-color-scheme: light)'
      />
      <meta
        name='theme-color'
        content='#000000'
        media='(prefers-color-scheme: dark)'
      />
    </Helmet>
  );
}
